
import { defineComponent, ref, reactive, toRefs, onMounted, computed, nextTick, watchEffect, watch } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import Table from '@/components/table.vue'
import { init, ECharts, EChartsOption } from 'echarts'
import Charts from '@/components/page/charts.vue'
import globalsets from '@/utils/globalsets'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  components: { Table, Charts, Nodata },
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  setup(props, context) {
    const pageData: any = reactive({
      columns: [],
      data: [],
      DividendSituationSummaryData: {}, // 分红概要
      option: {},
      spinning: true
    })
    const color = globalsets.getColor()
    pageData.columns = [
      {
        title: '报告期',
        dataIndex: 'bgq',
        key: 'bgq'
        // width: "100px"
      },
      {
        title: '预案报告期',
        dataIndex: 'yabgq',
        key: 'yabgq'
        // width: "100px"
      },
      {
        title: '分红方案说明',
        dataIndex: 'DividendPlan',
        key: 'DividendPlan',
        // width: "300px",
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      },
      {
        title: 'A股股权登记日',
        dataIndex: 'gqdjr',
        key: 'gqdjr',
        width: '120px'
      },
      {
        title: 'A股除权除息日',
        dataIndex: 'cqcxr',
        key: 'cqcxr',
        width: '120px'
      },
      {
        title: '分红金额(元)',
        dataIndex: 'TotalCashDivi',
        key: 'TotalCashDivi',
        width: '150px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '进度',
        dataIndex: 'EventProcedureDesc',
        key: 'EventProcedureDesc',
        width: '100px',
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      }
    ]
    watch(
      () => props.pageSourceData,
      () => {
        const data = (props.pageSourceData || {}).DividendSituationDetailData
        pageData.data = handlerData(data)

        const summary = (props.pageSourceData || {}).DividendSituationSummaryData || {}
        summary.date = (summary || {}).ListedDate ? window.moment(summary.ListedDate * 1000).format('YYYY-MM-DD') : '—'
        summary.total = globalsets.getNumber(summary.DividendTotal)
        pageData.DividendSituationSummaryData = summary
        nextTick(() => {
          pageData.spinning = false
          setOption()
        })
      },
      { deep: true }
    )
    function handlerData(arr: any) {
      if ((arr || []).length < 1) return []
      arr.forEach((item: any, i: number) => {
        item.index = 'Fhqk' + i
        item.bgq = item.EndDate ? window.moment(item.EndDate * 1000).format('YYYY-MM-DD') : '—'
        item.yabgq = item.AdvanceDate ? window.moment(item.AdvanceDate * 1000).format('YYYY-MM-DD') : '—'
        item.gqdjr = item.RightRegDate ? window.moment(item.RightRegDate * 1000).format('YYYY-MM-DD') : '—'
        item.cqcxr = item.ExDiviDate ? window.moment(item.ExDiviDate * 1000).format('YYYY-MM-DD') : '—'
      })
      return arr
    }
    function setOption() {
      const yAxisVal = pageData.data.map((item: any) => {
        return item.TotalCashDivi
      })
      const max2 = Math.max.apply(null, yAxisVal)
      const xAxisVal = pageData.data.map((item: any) => {
        return item.yabgq
      })
      pageData.option = {
        color: color,
        tooltip: {
          trigger: 'axis',
          borderWidth: 0,
          formatter: function(param: any) {
            const params = param[0]
            const val = params.value === 0 ? '送转不分红' : globalsets.getNumber(params.value) + '元'
            var htmlStr =
              '<div class="tool-tip"><span style="color:rgba(0,0,0,0.45);">' +
              params.name +
              '</span><br/> <span style="width: 8px;height: 8px;vertical-align: middle;display:inline-block;margn-right: 4px;background-color:' +
              params.color +
              '"></span><span style="color:#000;margin-left: 6px;">' +
              params.seriesName +
              '</span>' +
              '<span style="color:#000;float:right;margin-left: 12px">' +
              val +
              '</span><br/></div>'
            return htmlStr
          }
        },
        legend: {
          bottom: '15px',
          itemGap: 20,
          data: [],
          textStyle: {
            color: '#7d7d7d'
          }
        },
        grid: [
          {
            top: 50,
            left: 10,
            right: 50,
            bottom: 20,
            containLabel: true
          }
        ],
        toolbox: {
          // feature: {}
        },
        xAxis: [
          {
            type: 'category',
            data: xAxisVal,
            axisTick: {
              show: false
            },
            axisPointer: {
              type: 'shadow'
            }
            // axisTick: {
            //   alignWithLabel: true
            // }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '分红金额（元）',
            // nameTextStyle: {
            //   align: 'center'
            // },
            // min: 0,
            // max: 300,
            // splitNumber: 4,
            interval: Math.ceil(Math.ceil(max2) / 5),
            max: max2,
            axisLabel: {
              width: 180,
              formatter: function(value: any, index: number) {
                const num =
                  Math.abs(value) >= 100000000
                    ? (value / 100000000).toFixed(0) + '亿'
                    : Math.abs(value) >= 10000
                    ? (value / 10000).toFixed(0) + '万'
                    : parseFloat(value).toString() !== 'NaN'
                    ? value
                    : value || '—'
                return num
              }
            }
          }
        ],
        series: [
          {
            name: '分红金额',
            type: 'bar',
            yAxisIndex: 0,
            barWidth: 34,
            data: yAxisVal,
            label: {
              show: true,
              verticalAlign: 'top',
              position: 'top',
              offset: [0, -10],
              formatter: (params: any) => {
                return params.data === 0 ? '送转不分红' : ''
              }
            }
          }
        ]
      }
    }
    return {
      ...toRefs(pageData)
    }
  }
})
